import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { TotalSection } from './StyledComponents';

const TotalsAndActionsSection = ({
    t,
    formData,
    handleUpdate,
    onClose,
    onClear
}) => {
    return (
        <TotalSection>
            <Button
                variant="outlined"
                size="small"
                onClick={onClose}
                sx={{ minWidth: 80 }}
            >
                {t('Close')}
            </Button>
            <Button
                variant="outlined"
                size="small"
                onClick={onClear}
                sx={{ minWidth: 80 }}
            >
                {t('ClearAction') || t('Clear') || 'Clear'}
            </Button>
            <Box>
                <Typography variant="body1" gutterBottom sx={{ color: '#304FFF', fontWeight: 600 }}>
                    {t('TotalIncludingVAT')}: <span style={{ color: 'black' }}>{parseFloat(formData.totalIncludingVat || 0).toFixed(2)}</span>
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ color: '#304FFF', fontWeight: 600 }}>
                    {t('TotalToPay')}: <span style={{ color: 'black' }}>{parseFloat(formData.totalToPay || 0).toFixed(2)}</span>
                </Typography>
            </Box>
            <Box>
                <Typography variant="body1" gutterBottom sx={{ color: '#304FFF', fontWeight: 600 }}>
                    {t('TotalVatLiable')}: <span style={{ color: 'black' }}>{parseFloat(formData.totalVatLiable || 0).toFixed(2)}</span>
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ color: '#304FFF', fontWeight: 600 }}>
                    {t('TotalVAT')}: <span style={{ color: 'black' }}>{parseFloat(formData.totalVat || 0).toFixed(2)}</span>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                    variant="contained"
                    size="small"
                    onClick={handleUpdate}
                    sx={{ 
                        minWidth: 80,
                        backgroundColor: '#304FFF',
                        '&:hover': { backgroundColor: '#1a237e' }
                    }}
                >
                    {t('Add')}
                </Button>
            </Box>
        </TotalSection>
    );
};

export default TotalsAndActionsSection;